/* unplugin-vue-components disabled */import { render } from "./companyCulture.vue?vue&type=template&id=5c9971d8&scoped=true"
import script from "./companyCulture.vue?vue&type=script&lang=js"
export * from "./companyCulture.vue?vue&type=script&lang=js"

import "../../assets/css/init/column.less?vue&type=style&index=0&id=5c9971d8&lang=less&scoped=true"
import "../../assets/css/about/about.less?vue&type=style&index=1&id=5c9971d8&lang=less&scoped=true"

import exportComponent from "/Users/iwowke/Desktop/work/www/iwowke.com/src/m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c9971d8"]])

export default __exports__